import Loading from './Loading.vue'
import { merge } from '../../utils/helpers'
import { use, registerComponentProgrammatic } from '../../utils/plugins'
import { createApp } from 'vue'

const LoadingProgrammatic = {
  open(params) {
    const defaultParam = { programmatic: true, active: true }
    const app = createApp(Loading, merge(defaultParam, params))
    app.mount(document.createElement('div'))
    return app.unmount
  },
}

const Plugin = {
  install(Vue) {
    registerComponentProgrammatic(Vue, 'loading', LoadingProgrammatic)
  },
}

use(Plugin)

export default Plugin

export { LoadingProgrammatic }
